module.exports = __webpack_public_path__ + "img/3.f676d1c0.png";